import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Box, useMediaQuery } from "@chakra-ui/react";

import Navbar from "./Navbar";
import Footer from "./Footer";
import Sidebar from "./Sidebar";

import background from "../assets/LeaderBoredPortal_Background.webp";

// import TSModal from "../Components/Advertisement/TSModal";
// import FloatingButton from "./Popover/FloatingButton";

function Layout() {
  const location = useLocation();
  const path = location.pathname;

  const [isLargerThan768] = useMediaQuery("(min-width: 768px)");
  const [isSidebarToggled, setIsSidebarToggled] = useState(false);

  // const params = useParams();

  // THIS TRIGGERS THE FLOATING BUTTON'S SPEECH BUBBLE TO APPEAR WHEN THE MODAL CLOSES
  // const [showBubble, setShowBubble] = useState(false);

  // const [isMobile] = useMediaQuery("(max-width: 800px)");
  // const isPlayingMobile = isMobile && params.gameId;

  useEffect(() => {
    window.scroll(0, 0);
  }, [path]);

  // const modalCloseHandler = () => {
  //   // SHOW FLOATING BUTTON SPEECH BUBBLE WHEN MODAL CLOSES
  //   setShowBubble(true);
  // };


  return (
    <Box
      bg={`url(${background})`}
      bgAttachment='fixed'
      bgPos='top center'
    >
      {/* <TSModal onModalClose={modalCloseHandler} /> */}
      <Navbar isSidebarToggled={isSidebarToggled} setIsSidebarToggled={setIsSidebarToggled} />
      {isLargerThan768 &&
        <Sidebar isSidebarToggled={isSidebarToggled} setIsSidebarToggled={setIsSidebarToggled} />
      }

      <Box
        sx={isLargerThan768 ? {
          ml: isSidebarToggled ? '0' : '60px',
          transition: `
            margin-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)`,
        } : {
        }}
      >
        <Box
          pt='54px'
          pb='64px'
          minHeight='100vh'
        >
          <Box
            mt='56px'
            as='main'
            px={{ base: "4px", sm: "8px" }}
            mx='auto'
            minH='900px'
            maxW='1600px'
          // was maxW='1200px'
          >
            <Outlet />
            {/* <FloatingButton modalIsClose={showBubble} /> */}
          </Box>

          {/* {!isPlayingMobile && <FloatingButton modalIsClose={true} />} */}
        </Box>
        <Footer />
      </Box>
    </Box>
  );
}

export default Layout;
